// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

const firebaseConfig = {
    apiKey: "AIzaSyBhVT4Cjh94KRh2m_cdQJTRyYno5DkWT-A",
    authDomain: "encuesta-empresas-37b49.firebaseapp.com",
    projectId: "encuesta-empresas-37b49",
    storageBucket: "encuesta-empresas-37b49.appspot.com",
    messagingSenderId: "326295031183",
    appId: "1:326295031183:web:438c6ffe87ac1989420ffa"
};

const app = initializeApp(firebaseConfig);


export {
    app
};